import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useAppDispatch } from "../../hooks/redux";
import {
    CurrencyHelper,
    getItemsPaymentType,
    PaymentTypeHelper,
    getValidationSchema,
    PayerAccountHelper,
    getBusinessPaymentType,
} from "./FormHelpers/FormHelpers";
import { getValidationSchema as getBusinessValidationSchema } from "../BankTransferFormBusiness/FormHelpers/FormHelpers";
import { setPaymentRegionFilter } from "../../store/reducers/TransactionsSlice/TransactionsSlice";
import { useSelector } from "react-redux";
import { selectAccountsByFilter } from "../../store/reducers/TransactionsSlice/selector";
import GenerateTransactionForm from "../GenerateTransactionForm/GenerateTransactionForm";
import s from "./BankTransferFormPersonal.module.css";
import { myDate } from "../../helpers/CalculateDate";
import { phonecodes } from "../../constants/StaticData";

type PropsType = {
    setCurrent?: Dispatch<SetStateAction<number>>;
    setTransferData?: Dispatch<SetStateAction<any>>;
    id?: string | number;
};

const BankTransferFormPersonal = (props: PropsType) => {

    const {
        id,
        setCurrent,
        setTransferData
    } = props;

    const [paymentType, setPaymentType] = useState("SHA");
    const [paymentRegion, setPaymentRegion] = useState("");
    const [currency, setCurrency] = useState("");
    const dispatch = useAppDispatch();

    const [date, setDate] = useState({
        from:
            myDate.getFullYear() +
            "-" +
            (myDate.getMonth() + 1 < 10
                ? ("0" + (myDate.getMonth() + 1)).slice(-2)
                : myDate.getMonth() + 1) +
            "-" +
            myDate.getDate(),
    });

    const accountsList = useSelector(selectAccountsByFilter);

    // eslint-disable-next-line 
    const [code, setCode] = useState({
        co: "ad",
        ph: "376",
        na: "Andorra",
    });

    const [paymentTypeByRegion, setPaymentTypeByRegion] = useState("");

    useEffect(() => {
        dispatch(setPaymentRegionFilter(paymentRegion));
        return () => {
            localStorage.removeItem("transfer-form");
        };
    }, [paymentRegion, dispatch]);

    // Recipient's Type
    const [selectedOptionRecipientType, setSelectedOptionRecipientType] =
        useState("INDIVIDUAL");

    const findRelatedValidationSchema = () => {
        if (selectedOptionRecipientType === "INDIVIDUAL") {
            return getValidationSchema(paymentTypeByRegion, paymentRegion);
        } else {
            return getBusinessValidationSchema(
                paymentTypeByRegion,
                paymentRegion
            );
        }
    };

    const getCountryCode = (countryName: string) => {
        const country = phonecodes.find((entry) => entry.na === countryName);
        return country?.co;
    };

    return (
        <div>
            <motion.div
                initial={{ opacity: 0, scale: 1 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
            >
                <GenerateTransactionForm
                    s={s}
                    id={id}
                    accountsList={accountsList}
                    selectedOptionRecipientType={selectedOptionRecipientType}
                    findRelatedValidationSchema={findRelatedValidationSchema}
                    currency={currency}
                    paymentType={paymentType}
                    CurrencyHelper={CurrencyHelper}
                    PaymentTypeHelper={PaymentTypeHelper}
                    PayerAccountHelper={PayerAccountHelper}
                    setPaymentType={setPaymentType}
                    setCurrent={setCurrent}
                    setTransferData={setTransferData}
                    setPaymentRegion={setPaymentRegion}
                    setCurrency={setCurrency}
                    setSelectedOptionRecipientType={
                        setSelectedOptionRecipientType
                    }
                    getItemsPaymentType={getItemsPaymentType}
                    getBusinessPaymentType={getBusinessPaymentType}
                    setPaymentTypeByRegion={setPaymentTypeByRegion}
                    setCode={setCode}
                    generateType="personalTransferForm"
                    setDate={setDate}
                    date={date}
                    initialValues={{
                        payerAccount: "",
                        paymentRegions: "",
                        paymentType: "",
                        paymentTypeByRegionForm: "",
                        bankCode: {
                            name: "",
                            value: "",
                        },
                        bankAccount: "",
                        bankAccountType: {
                            name: "",
                            value: "",
                        },
                        fullName: "",
                        firstName: "",
                        lastName: "",
                        companyName: "",
                        middleName: "",
                        recipientsAddress: "",
                        beneficiaryState: "",
                        recipientsCity: "",
                        recipientsZipCode: "",
                        recipientsCountry: "",
                        recipientsAccountNumber: "",
                        recipientsSwiftBic: "",
                        recipientsIban: "",
                        recipientsBankCountry: "",
                        recipientsBankCity: "",
                        recipientsBankState: "",
                        recipientsBankAddress: "",
                        recipientsBankZipCode: "",
                        recipientsBank: "",
                        email: "",
                        emailLanguage: "EN",
                        paymentDate: date.from,
                        transferCurrency: "USD",
                        purpose: "",
                        reference: "",
                        templateName: "",
                        amount: "",
                        type: "international",
                        phoneNumber: "",
                        recipientCountry: {
                            name: "",
                            value: "",
                        },
                        recipientCity: "",
                        mobileProvider: {
                            name: "",
                            value: "",
                        },
                        street: "",
                        city: "",
                        postalCode: "",
                        identityCardId: "",
                        identityCardType: {
                            name: "",
                            value: "",
                        },
                        transferReason: {
                            name: "",
                            value: "",
                        },
                        routingNumber: "",
                        cashProvider: "",
                        branchCode: {
                            name: "",
                            value: "",
                        },
                        branchCodeTED: "",
                        pixKeyType: {
                            name: "",
                            value: "",
                        },
                        pixKeyValue: "",
                        relationshipToSender: "",
                        institutionNumber: "",
                        transitNumber: "",
                        uniqueId: "",
                        sortCode: "",
                        senderIdType: {
                            name: "",
                            value: "",
                        },
                        senderIdNumber: "",
                        beneficiaryName: "",
                        beneficiaryEmail: "",
                        securityQuestion: "",
                        securityAnswer: "",
                        payeeName: "",
                        payeeCode: "",
                        payeeAccountNumber: "",
                        invoice: "",
                        name: "", // for business
                        natureOfBusiness: {
                            name: "",
                            value: "",
                        }, // for business
                        registrationNumber: "", // for business
                        legalEntityType: {
                            name: "",
                            value: "",
                        }, // for business
                        recipientType: selectedOptionRecipientType,
                    }}
                    onSubmit={(values) => {
                        let tempData = {
                            ...values,
                            recipientsCountry: ((values.paymentRegions).toUpperCase() !== "PAN AFRICA") ? getCountryCode(values.recipientsCountry) : values.recipientsCountry,
                            recipientsBankCountry: ((values.paymentRegions).toUpperCase() !== "PAN AFRICA") ? getCountryCode(values.recipientsBankCountry) : values.recipientsBankCountry,
                            phoneNumber:
                                values.phoneNumber !== ""
                                    ? values.phoneNumber
                                    : "",
                            transferCurrency: currency,
                            paymentDate: date.from,
                        };

                        if (
                            values.paymentRegions.toLowerCase() ===
                            "swift (international transfer)"
                        ) {
                            tempData = { ...tempData, paymentType };
                        }

                        setTransferData &&
                            setTransferData(tempData);
                        setCurrent && setCurrent(1);
                    }}
                />
            </motion.div>
        </div>
    );
};

export default BankTransferFormPersonal;
